import { Outlet } from 'react-router-dom';

/**
 * Dashboard shell — renders child routes via Outlet.
 *
 * DashboardLayout is hoisted above TeamGuard in dashboard.routes.tsx so the
 * sidebar stays mounted during the skeleton→content transition (prevents jank).
 */
export default function Dashboard() {
  return <Outlet />;
}
